define(
//begin v1.x content
({
	buttonOk: "Labi",
	buttonCancel: "Atcelt",
	buttonSave: "Saglabāt",
	itemClose: "Aizvērt"
})
//end v1.x content
);
